import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

////////////////////////////////////////////////////////////////////

export default class BSTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    //
  }

  componentWillUnmount() {
    //
  }

  render() {
    var arr = [];
    this.props.rows.forEach(function(el){
      elTraverse(el);
    });

    function elTraverse(el, name){
      var key = name ? [name, el.data_name].join(".") : el.data_name;
      el.r_key = key;
      arr.push(el);
      if (el.hasOwnProperty("elements")){
        el.elements.forEach(function(e){
          elTraverse(e, key);
        });
      }
    }

    arr.forEach(function(el){
      el.vis_conditions = el.visible_conditions !== null ? el.visible_conditions.map(condition_formatter).join(", ") : "";
      el.choices_s = el.hasOwnProperty("choices") ? el.choices.map(choices_formatter).join(", ") :
        el.hasOwnProperty("positive") && el.type === "YesNoField" ? mapYesNo(el) : "";
      el.type = el.type === "ChoiceField" ?
        !el.multiple ? "SingleChoice" : "MultipleChoice"
          : el.type;
    });

    function condition_formatter(c){
      try {
        var first = arr.find(function(b){ return b.key === c.field_key}).label;
      }catch(err){
        first = c.field_key;
      }
      return first +" "+c.operator.replace("_", " ")+" "+c.value;
    }

    function choices_formatter(d){
      return [d.label, d.value].join(":");
    }

    function mapYesNo(el){
      var fields = ["positive", "negative"];
      if (el.neutral_enabled){
        fields.push("neutral");
      }
      return fields.map(function(k){ return [el[k].label, el[k].value].join(":") }).join(", ");
    }

    const cellEdit = {
      mode: "dbclick"
    };

    return (
      <BootstrapTable data={ arr }
        striped
        hover
        bordered
        search
        multiColumnSearch
        exportCSV
        keyBoardNav
        csvFileName={ this.props.filename }
        cellEdit={ cellEdit }>
        <TableHeaderColumn dataField="label" isKey={ true }>Data Label</TableHeaderColumn>
        <TableHeaderColumn dataField="data_name" >Data Name</TableHeaderColumn>
        <TableHeaderColumn dataField="description" >Description</TableHeaderColumn>
        <TableHeaderColumn dataField="type" >Question Type</TableHeaderColumn>
        <TableHeaderColumn dataField="vis_conditions" >Visibility Conditions</TableHeaderColumn>
        <TableHeaderColumn dataField="choices_s" >Choices (label:value)</TableHeaderColumn>
      </BootstrapTable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/table.js